import * as Types from '../graphQlTypes.generated';

import { graphQlService } from '@doxyme/frontend/services/graphql.service';
export type GetRoomsForUserQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.RoomsForUserInput>;
}>;


export type GetRoomsForUserQuery = { __typename?: 'Query', Room: { __typename?: 'RoomQueries', getRoomsForUser: { __typename?: 'RoomConnectionDto', edges: Array<{ __typename?: 'RoomEdgeDto', node: { __typename?: 'Room', id: string, membershipType: Types.MembershipType, slug: string, roomRootSlug?: string | null, passcode?: string | null, isPasscodeEnabled: boolean, sharedRoomDisplayName?: string | null, cameraOff: boolean, owner?: { __typename?: 'RoomOwner', id: string, title?: string | null, firstName: string, lastName: string, displayName?: string | null } | null } }> } } };

export type IsSlugUniqueQueryVariables = Types.Exact<{
  input: Types.SlugInput;
}>;


export type IsSlugUniqueQuery = { __typename?: 'Query', Room: { __typename?: 'RoomQueries', isSlugUnique: boolean } };

export type IsSubSlugUniqueQueryVariables = Types.Exact<{
  input: Types.SlugInput;
}>;


export type IsSubSlugUniqueQuery = { __typename?: 'Query', Room: { __typename?: 'RoomQueries', isSubSlugUnique: boolean } };

export type UpdateRoomMutationVariables = Types.Exact<{
  input: Types.RoomUpdateDto;
}>;


export type UpdateRoomMutation = { __typename?: 'Mutation', updateRoom: { __typename?: 'Room', id: string, membershipType: Types.MembershipType, slug: string, roomRootSlug?: string | null, passcode?: string | null, isPasscodeEnabled: boolean, sharedRoomDisplayName?: string | null, cameraOff: boolean, ownerId?: string | null } };

export type IsValidPasscodeForRoomMutationVariables = Types.Exact<{
  input: Types.RoomPasscodeInput;
}>;


export type IsValidPasscodeForRoomMutation = { __typename?: 'Mutation', isValidPasscodeForRoom: boolean };

export type NotifyMembersAboutPatientMutationVariables = Types.Exact<{
  input: Types.NotifyMembersAboutPatientInput;
}>;


export type NotifyMembersAboutPatientMutation = { __typename?: 'Mutation', notifyMembersAboutPatient: boolean };

export type DeletePersonalRoomMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type DeletePersonalRoomMutation = { __typename?: 'Mutation', deletePersonalRoom: boolean };

export type DeleteSharedRoomMutationVariables = Types.Exact<{
  input: Types.DeleteSharedRoomInput;
}>;


export type DeleteSharedRoomMutation = { __typename?: 'Mutation', deleteSharedRoom: boolean };

export type RemoveRoomMemberMutationVariables = Types.Exact<{
  input: Types.RemoveRoomMemberInput;
}>;


export type RemoveRoomMemberMutation = { __typename?: 'Mutation', removeRoomMember: boolean };

export type AddRoomMembersMutationVariables = Types.Exact<{
  input: Types.AddRoomMembersInput;
}>;


export type AddRoomMembersMutation = { __typename?: 'Mutation', addRoomMembers: Array<string> };

export type CreateSharedRoomMutationVariables = Types.Exact<{
  input: Types.CreateSharedRoomInput;
}>;


export type CreateSharedRoomMutation = { __typename?: 'Mutation', createSharedRoom: { __typename?: 'CreateSharedRoomResult', roomId: string } };

export type SubmitPersonalRoomToOgMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type SubmitPersonalRoomToOgMutation = { __typename?: 'Mutation', submitPersonalRoomToOg: { __typename?: 'SubmitPersonalRoomToOgResultDto', success: boolean, legacyRoomId?: number | null } };

export type GetRoomForPatientQueryVariables = Types.Exact<{
  input: Types.SlugInput;
}>;


export type GetRoomForPatientQuery = { __typename?: 'Query', Room: { __typename?: 'RoomQueries', getRoomForPatient?: { __typename?: 'RoomForPatient', id: string, legacyId?: number | null, slug: string, isPersonal: boolean, shouldRedirect?: boolean | null, redirectUrl?: string | null, checkInPhotoCapture: boolean, isPasscodeEnabled: boolean, sharedRoomDisplayName?: string | null, tenantId: string, owner?: { __typename?: 'RoomOwnerForPatient', id: string, title?: string | null, firstName: string, lastName: string, displayName?: string | null, userProfilePictureUrl?: string | null, subscriptionType: Types.UserSubscriptionType, legacyUserId?: string | null } | null, providerEntitlements?: { __typename?: 'ProviderEntitlementsForPatient', features: Array<Types.ProviderFeatureKey> } | null } | null } };

export type IsUsingNativeRoomsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type IsUsingNativeRoomsQuery = { __typename?: 'Query', Room: { __typename?: 'RoomQueries', isUsingNativeRooms: boolean } };

export type GetRoomsForTenantQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.RoomsForTenantInput>;
}>;


export type GetRoomsForTenantQuery = { __typename?: 'Query', Room: { __typename?: 'RoomQueries', getRoomsForTenant: { __typename?: 'RoomsForTenant', members?: Array<{ __typename?: 'RoomMember', id: string, title?: string | null, firstName: string, lastName: string, displayName?: string | null, userProfilePictureUrl?: string | null, isPending: boolean }> | null, edges: Array<{ __typename?: 'RoomWithMembersEdge', node: { __typename?: 'RoomWithMembers', roomMemberIds: Array<string>, room: { __typename?: 'Room', id: string, slug: string, isPasscodeEnabled: boolean, membershipType: Types.MembershipType, ownerId?: string | null, sharedRoomDisplayName?: string | null, passcode?: string | null, cameraOff: boolean } } }> } } };

export type GetMatchingRoomsQueryVariables = Types.Exact<{
  input: Types.GetMatchingRoomsInput;
}>;


export type GetMatchingRoomsQuery = { __typename?: 'Query', Room: { __typename?: 'RoomQueries', getMatchingRooms: Array<{ __typename?: 'MatchingRoom', rootSlug: string, subSlug: string }> } };

export type GetIsClinicSlugQueryVariables = Types.Exact<{
  input: Types.GetIsClinicSlugInput;
}>;


export type GetIsClinicSlugQuery = { __typename?: 'Query', Room: { __typename?: 'RoomQueries', isClinicSlug: boolean } };


export const GetRoomsForUserDocument = `
    query GetRoomsForUser($input: RoomsForUserInput) {
  Room {
    getRoomsForUser(input: $input) {
      edges {
        node {
          id
          membershipType
          slug
          roomRootSlug
          passcode
          isPasscodeEnabled
          sharedRoomDisplayName
          cameraOff
          owner {
            id
            title
            firstName
            lastName
            displayName
          }
        }
      }
    }
  }
}
    `;
export const IsSlugUniqueDocument = `
    query IsSlugUnique($input: SlugInput!) {
  Room {
    isSlugUnique(input: $input)
  }
}
    `;
export const IsSubSlugUniqueDocument = `
    query IsSubSlugUnique($input: SlugInput!) {
  Room {
    isSubSlugUnique(input: $input)
  }
}
    `;
export const UpdateRoomDocument = `
    mutation UpdateRoom($input: RoomUpdateDto!) {
  updateRoom(input: $input) {
    id
    membershipType
    slug
    roomRootSlug
    passcode
    isPasscodeEnabled
    sharedRoomDisplayName
    cameraOff
    ownerId
  }
}
    `;
export const IsValidPasscodeForRoomDocument = `
    mutation IsValidPasscodeForRoom($input: RoomPasscodeInput!) {
  isValidPasscodeForRoom(input: $input)
}
    `;
export const NotifyMembersAboutPatientDocument = `
    mutation NotifyMembersAboutPatient($input: NotifyMembersAboutPatientInput!) {
  notifyMembersAboutPatient(input: $input)
}
    `;
export const DeletePersonalRoomDocument = `
    mutation DeletePersonalRoom {
  deletePersonalRoom
}
    `;
export const DeleteSharedRoomDocument = `
    mutation DeleteSharedRoom($input: DeleteSharedRoomInput!) {
  deleteSharedRoom(input: $input)
}
    `;
export const RemoveRoomMemberDocument = `
    mutation RemoveRoomMember($input: RemoveRoomMemberInput!) {
  removeRoomMember(input: $input)
}
    `;
export const AddRoomMembersDocument = `
    mutation AddRoomMembers($input: AddRoomMembersInput!) {
  addRoomMembers(input: $input)
}
    `;
export const CreateSharedRoomDocument = `
    mutation CreateSharedRoom($input: CreateSharedRoomInput!) {
  createSharedRoom(input: $input) {
    roomId
  }
}
    `;
export const SubmitPersonalRoomToOgDocument = `
    mutation SubmitPersonalRoomToOg {
  submitPersonalRoomToOg {
    success
    legacyRoomId
  }
}
    `;
export const GetRoomForPatientDocument = `
    query GetRoomForPatient($input: SlugInput!) {
  Room {
    getRoomForPatient(input: $input) {
      id
      legacyId
      slug
      isPersonal
      shouldRedirect
      redirectUrl
      checkInPhotoCapture
      isPasscodeEnabled
      sharedRoomDisplayName
      tenantId
      owner {
        id
        title
        firstName
        lastName
        displayName
        userProfilePictureUrl
        subscriptionType
        legacyUserId
      }
      providerEntitlements {
        features
      }
    }
  }
}
    `;
export const IsUsingNativeRoomsDocument = `
    query IsUsingNativeRooms {
  Room {
    isUsingNativeRooms
  }
}
    `;
export const GetRoomsForTenantDocument = `
    query GetRoomsForTenant($input: RoomsForTenantInput) {
  Room {
    getRoomsForTenant(input: $input) {
      members {
        id
        title
        firstName
        lastName
        displayName
        userProfilePictureUrl
        isPending
      }
      edges {
        node {
          room {
            id
            slug
            isPasscodeEnabled
            membershipType
            ownerId
            sharedRoomDisplayName
            passcode
            cameraOff
          }
          roomMemberIds
        }
      }
    }
  }
}
    `;
export const GetMatchingRoomsDocument = `
    query GetMatchingRooms($input: GetMatchingRoomsInput!) {
  Room {
    getMatchingRooms(input: $input) {
      rootSlug
      subSlug
    }
  }
}
    `;
export const GetIsClinicSlugDocument = `
    query GetIsClinicSlug($input: GetIsClinicSlugInput!) {
  Room {
    isClinicSlug(input: $input)
  }
}
    `;

const injectedRtkApi = graphQlService.injectEndpoints({
  endpoints: (build) => ({
    GetRoomsForUser: build.query<GetRoomsForUserQuery, GetRoomsForUserQueryVariables | void>({
      query: (variables) => ({ document: GetRoomsForUserDocument, variables })
    }),
    IsSlugUnique: build.query<IsSlugUniqueQuery, IsSlugUniqueQueryVariables>({
      query: (variables) => ({ document: IsSlugUniqueDocument, variables })
    }),
    IsSubSlugUnique: build.query<IsSubSlugUniqueQuery, IsSubSlugUniqueQueryVariables>({
      query: (variables) => ({ document: IsSubSlugUniqueDocument, variables })
    }),
    UpdateRoom: build.mutation<UpdateRoomMutation, UpdateRoomMutationVariables>({
      query: (variables) => ({ document: UpdateRoomDocument, variables })
    }),
    IsValidPasscodeForRoom: build.mutation<IsValidPasscodeForRoomMutation, IsValidPasscodeForRoomMutationVariables>({
      query: (variables) => ({ document: IsValidPasscodeForRoomDocument, variables })
    }),
    NotifyMembersAboutPatient: build.mutation<NotifyMembersAboutPatientMutation, NotifyMembersAboutPatientMutationVariables>({
      query: (variables) => ({ document: NotifyMembersAboutPatientDocument, variables })
    }),
    DeletePersonalRoom: build.mutation<DeletePersonalRoomMutation, DeletePersonalRoomMutationVariables | void>({
      query: (variables) => ({ document: DeletePersonalRoomDocument, variables })
    }),
    DeleteSharedRoom: build.mutation<DeleteSharedRoomMutation, DeleteSharedRoomMutationVariables>({
      query: (variables) => ({ document: DeleteSharedRoomDocument, variables })
    }),
    RemoveRoomMember: build.mutation<RemoveRoomMemberMutation, RemoveRoomMemberMutationVariables>({
      query: (variables) => ({ document: RemoveRoomMemberDocument, variables })
    }),
    AddRoomMembers: build.mutation<AddRoomMembersMutation, AddRoomMembersMutationVariables>({
      query: (variables) => ({ document: AddRoomMembersDocument, variables })
    }),
    CreateSharedRoom: build.mutation<CreateSharedRoomMutation, CreateSharedRoomMutationVariables>({
      query: (variables) => ({ document: CreateSharedRoomDocument, variables })
    }),
    SubmitPersonalRoomToOg: build.mutation<SubmitPersonalRoomToOgMutation, SubmitPersonalRoomToOgMutationVariables | void>({
      query: (variables) => ({ document: SubmitPersonalRoomToOgDocument, variables })
    }),
    GetRoomForPatient: build.query<GetRoomForPatientQuery, GetRoomForPatientQueryVariables>({
      query: (variables) => ({ document: GetRoomForPatientDocument, variables })
    }),
    IsUsingNativeRooms: build.query<IsUsingNativeRoomsQuery, IsUsingNativeRoomsQueryVariables | void>({
      query: (variables) => ({ document: IsUsingNativeRoomsDocument, variables })
    }),
    GetRoomsForTenant: build.query<GetRoomsForTenantQuery, GetRoomsForTenantQueryVariables | void>({
      query: (variables) => ({ document: GetRoomsForTenantDocument, variables })
    }),
    GetMatchingRooms: build.query<GetMatchingRoomsQuery, GetMatchingRoomsQueryVariables>({
      query: (variables) => ({ document: GetMatchingRoomsDocument, variables })
    }),
    GetIsClinicSlug: build.query<GetIsClinicSlugQuery, GetIsClinicSlugQueryVariables>({
      query: (variables) => ({ document: GetIsClinicSlugDocument, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useGetRoomsForUserQuery, useLazyGetRoomsForUserQuery, useIsSlugUniqueQuery, useLazyIsSlugUniqueQuery, useIsSubSlugUniqueQuery, useLazyIsSubSlugUniqueQuery, useUpdateRoomMutation, useIsValidPasscodeForRoomMutation, useNotifyMembersAboutPatientMutation, useDeletePersonalRoomMutation, useDeleteSharedRoomMutation, useRemoveRoomMemberMutation, useAddRoomMembersMutation, useCreateSharedRoomMutation, useSubmitPersonalRoomToOgMutation, useGetRoomForPatientQuery, useLazyGetRoomForPatientQuery, useIsUsingNativeRoomsQuery, useLazyIsUsingNativeRoomsQuery, useGetRoomsForTenantQuery, useLazyGetRoomsForTenantQuery, useGetMatchingRoomsQuery, useLazyGetMatchingRoomsQuery, useGetIsClinicSlugQuery, useLazyGetIsClinicSlugQuery } = injectedRtkApi;

